<template>
<div class="modal-overlay" @click.self="$emit('close')">
  <div class="modal">
    <div class="modal-top"><h3 class="modal-caption">検針データ入力[ {{ name }}さま ]</h3></div>
    <div class="modal-content">
      <div class="err_message">
        {{ errors.first("allday1") }}
      </div>
      <div class="err_message">
        {{ errors.first("noon1") }}
      </div>
      <div class="err_message">
        {{ errors.first("allday2") }}
      </div>
      <div class="err_message">
        {{ errors.first("noon2") }}
      </div>
      <div class="two-tables">
        <div class="two-tables-item">
          <h4 class="table-caption">{{ dispYear }}年</h4>
          <table class="normal-table" style="width: 530px; height: 558px;padding:0">
            <thead>
              <tr style="max-width: 430px;height: 54px;">
                <th style="max-width: 91px;height: 41px;;padding:0">日付</th>
                <th style="max-width: 113px;height: 41px;;padding:0">全日電力量<br>（kWh）</th>
                <th style="max-width: 113px;height: 41px;;padding:0">昼間電力量<br>（kWh）</th>
                <th style="max-width: 113px;height: 41px;;padding:0">夜間電力量<br>（kWh）</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in dispMeterDataList1" v-bind:key="index">
                <td style="max-width: 91px;height: 41px;;padding:0">{{ getDateStr(item.date) }}</td>
                <td style="max-width: 113px;height: 41px; padding: 0">
                  <input type="number"
                   class="cell-input-field"
                   name="allday1"
                   data-vv-as="全日電力量"
                   :style="getStyle(item.allday)"
                   v-model="item.allday"
                   v-validate="'min_value:0.00|max_value:9999999.99'"
                   @change="changeValue(1, index)">
                </td>
                <td style="max-width: 113px;height: 41px; padding: 0">
                  <input type="number"
                   class="cell-input-field"
                   name="noon1"
                   data-vv-as="昼間電力量"
                   :style="getStyle(item.noon)"
                   v-model="item.noon"
                   v-validate="'min_value:0.00|max_value:9999999.99'"
                   @change="changeValue(1, index)">
                </td>
                <td style="max-width: 113px;height: 41px; padding: 0"><input type="text" class="cell-input-field" v-model="item.night" disabled></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="two-tables-item">
          <h4 class="table-caption">{{ dispYear - 1 }}年</h4>
          <table class="normal-table" style="width: 530px; height: 558px;padding:0">
            <thead>
              <tr style="max-width: 430px;height: 54px;;padding:0">
                <th style="max-width: 91px;height: 41px;;padding:0">日付</th>
                <th style="max-width: 113px;height: 41px;;padding:0">全日電力量<br>（kWh）</th>
                <th style="max-width: 113px;height: 41px;;padding:0">昼間電力量<br>（kWh）</th>
                <th style="max-width: 113px;height: 41px;;padding:0">夜間電力量<br>（kWh）</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in dispMeterDataList2" v-bind:key="index">
                <td style="max-width: 91px;height: 41px;;padding:0">{{ getDateStr(item.date) }}</td>
                <td style="max-width: 113px;height: 41px; padding: 0">
                  <input type="number"
                   class="cell-input-field"
                   name="allday2"
                   data-vv-as="全日電力量"
                   :style="getStyle(item.allday)"
                   v-model="item.allday"
                   v-validate="'min_value:0.00|max_value:9999999.99'"
                   @change="changeValue(2, index)">
                </td>
                <td style="max-width: 113px;height: 41px; padding: 0">
                  <input type="number"
                   class="cell-input-field"
                   name="noon2"
                   data-vv-as="昼間電力量"
                   :style="getStyle(item.noon)"
                   v-model="item.noon"
                   v-validate="'min_value:0.00|max_value:9999999.99'"
                   @change="changeValue(2, index)">
                </td>
                <td style="max-width: 113px;height: 41px; padding: 0"><input type="text" class="cell-input-field" v-model="item.night" disabled></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-bottom">
        <ul class="modal-bottom-pager">
          <li class="modal-bottom-pager-item"><a href="javascript:void(0);" class="bt-cyan" @click="onNext">&lt;</a></li>
          <li class="modal-bottom-pager-item"><a href="javascript:void(0);" class="bt-cyan" @click="onPrev">&gt;</a></li>
        </ul>
        <ul class="modal-bottom-button">
          <li class="modal-bottom-button-item"><a href="javascript:void(0);" class="bt-gray" style="width: 140px;" @click="onCancel">保存せずに閉じる</a></li>
          <li class="modal-bottom-button-item"><a href="javascript:void(0);" class="bt-cyan" @click="onRegist">登録</a></li>
        </ul>
      </div>
    </div>
  </div>
</div>
</template>
<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
export default {
  name: "meter-dialog",
  props: ["account", "name"],
  data: function() {
    return {
      dispYear: 0,
      meterDataList: [],
      dispMeterDataList1: [],
      dispMeterDataList2: [],
      changeValueFlg: false
    };
  },
  mounted: function() {
    console.log("MeterDialog:mounted");
    var today = new Date();
    this.dispYear = today.getFullYear();
    this.getData();
  },
  methods: {
    getData: function() {
      console.log("getData");

      this.$axios
        .get(`/srv/api/meter_data/${this.account}`, {
          withCredentials: true
        })
        .then(response => {
          console.log("meter_data success");
          console.log(response.data);
          if (typeof response.data == "object") {
            console.log("OK");
            this.meterDataList = response.data.meter_list;
            console.log(this.meterDataList);
            this.dispData();
          } else {
            // stinrgのときはセッションタイムアウト
            alert("sesssion time out");
            this.$store.dispatch("logout");
            this.$router.push("/login");
          }
        })
        .catch(error => {
          console.log("meter_data error");
          console.log(error);
        });
    },
    changeValue: function(list, key) {
      console.log("changeValue");
      if (list == 1) {
        this.dispMeterDataList1[key].night = this.dispMeterDataList1[key].allday - this.dispMeterDataList1[key].noon;
      } else if (list == 2) {
        this.dispMeterDataList2[key].night = this.dispMeterDataList2[key].allday - this.dispMeterDataList2[key].noon;
      }
      this.changeValueFlg = true;
    },
    dispData: function() {
      console.log("dispData");
      this.dispMeterDataList1 = [];
      this.dispMeterDataList2 = [];

      let roopYear = this.dispYear;
      this.setData(1, roopYear);
      this.setData(2, roopYear - 1);
      
    },
    setData: function(list, year) {
      console.log("setData");
      let roopYear = year;
      let roopMonth = 4;
      let self = this.dispMeterDataList1;

      if (list == 1) {
        self = this.dispMeterDataList1;
      } else if (list == 2) {
        self = this.dispMeterDataList2;
      }

      for (let i = 0; i < 12; i++) {
        let isData = false;
        let month = (roopMonth + i) % 12;
        if (month == 0) {
          month = 12;
        } else if (month == 1) {
          roopYear++;
        }
        const yearMonth = roopYear + (('00' + month).slice(-2));
        for (let j = 0; j < this.meterDataList.length; j++) {
          if (this.meterDataList[j].date == yearMonth) {
            let meterData = {
              date: yearMonth,
              allday: this.meterDataList[j].allday_value,
              noon: this.meterDataList[j].noon_value,
              night: (this.meterDataList[j].allday_value == null || this.meterDataList[j].noon_value == null) ? "" : (this.meterDataList[j].allday_value - this.meterDataList[j].noon_value)
            };
            self.push(meterData);
            isData = true;
            break;
          }
        }

        if (!isData) {
          let meterData = {
            date: yearMonth,
            allday: "",
            noon: "",
            night: ""
          };
          self.push(meterData);
        }
      }
    },
    getDateStr: function(date) {
      if (date.length != 6) {
        return date;
      }
      return date.slice(0, 4) + "年" + date.slice(-2) + "月";
    },
    onCancel: function() {
      const ans = confirm('保存せずに終了しますか？');
      if (ans) {
        this.changeValueFlg = false;
        this.$emit("close");
      }
    },
    onRegist: function() {
      const ans = confirm('登録しますか？');
      if (ans) {
        this.$validator.validateAll().then(result => {
          if (result) {
            let meterList = [];
            for (let i = 0; i < this.dispMeterDataList1.length; i++) {
              let data = {
                date: this.dispMeterDataList1[i].date,
                allday_value: this.dispMeterDataList1[i].allday,
                noon_value: this.dispMeterDataList1[i].noon
              };
              meterList.push(data);
            }
            for (let i = 0; i < this.dispMeterDataList2.length; i++) {
              let data = {
                date: this.dispMeterDataList2[i].date,
                allday_value: this.dispMeterDataList2[i].allday,
                noon_value: this.dispMeterDataList2[i].noon
              };
              meterList.push(data);
            }

            let param = {
              meter_list: meterList
            };
            this.$axios
              .post(`/srv/api/meter_data/${this.account}`, param, {
                withCredentials: true
              })
              .then(response => {
                console.log(response.data);
                const data = response.data;
                if (data.status !== undefined) {
                  if (data.status === "success") {
                    this.getData();
                    this.changeValueFlg = false;
                  } else {
                    console.log("error");
                    alert("登録できませんでした");
                  }
                } else {
                  console.log("error");
                  alert("登録できませんでした");
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            alert("エラー内容を確認してください。");
          }
        });
      }
    },
    onNext: function() {
      console.log("onNext");
      const today = new Date();
      if (today.getFullYear() > this.dispYear) {
        if (this.changeValueFlg) {
          const ans = confirm('変更内容は反映されていませんが、画面を移動しますか？');
          if (ans) {
            this.dispYear += 2;
            this.dispData();
            this.changeValueFlg = false;
          }
        } else {
          this.dispYear += 2;
          this.dispData();
          this.changeValueFlg = false;
        }
      }
    },
    onPrev: function() {
      console.log("onPrev");
      if ((this.dispYear -2) >= 2015) {
        if (this.changeValueFlg) {
          const ans = confirm('変更内容は反映されていませんが、画面を移動しますか？');
          if (ans) {
            this.dispYear -= 2;
            this.dispData();
            this.changeValueFlg = false;
          }
        } else {
          this.dispYear -= 2;
          this.dispData();
          this.changeValueFlg = false;
        }
      }
    },
    getStyle: function(value) {
      const num = Number(value);
      if (!isNaN(num) && (num > 9999999.99 || num < 0)) {
        return "background-color: #f00";
      }
      return "";
    }
  }
};
</script>